import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export const FestiveBanner = () => {
  const { config } = useStore();
  const b = config.festive_banner;
  if (!b?.enabled || !b.title) return null;
  return (
    <section className="relative z-[5] max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 -mt-6 sm:-mt-10 mb-6" data-testid="festive-banner">
      <motion.div initial={{ opacity: 0, y: 30, scale: 0.98 }} whileInView={{ opacity: 1, y: 0, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
        className="relative overflow-hidden rounded-3xl border border-[#D4AF37]/50 bg-[linear-gradient(115deg,#2A1610_0%,#4A2A1C_45%,#2A1610_100%)] shadow-[0_30px_80px_-30px_rgba(212,175,55,0.45)]">
        <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_15%_50%,#D4AF37_0,transparent_35%),radial-gradient(circle_at_85%_40%,#E6C594_0,transparent_30%)]" />
        <div className="absolute inset-0 festive-shimmer pointer-events-none" />
        <img src="/catalogue/decor/gift-box.webp" alt="" aria-hidden className="hidden md:block absolute right-0 top-0 h-full w-[34%] object-cover opacity-40 [mask-image:linear-gradient(to_left,black,transparent)]" />
        <div className="relative px-6 py-8 sm:px-12 sm:py-12 text-center md:text-left md:max-w-[68%]">
          {b.eyebrow && (
            <span data-testid="festive-banner-eyebrow" className="inline-flex items-center gap-2 text-[10px] sm:text-xs tracking-[0.35em] uppercase text-[#E6C594] border border-[#D4AF37]/40 rounded-full px-3 py-1">
              <Sparkles size={12} className="text-[#D4AF37]" /> {b.eyebrow}
            </span>
          )}
          <h2 data-testid="festive-banner-title" className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-wide gold-gradient-text leading-tight">{b.title}</h2>
          {b.subtitle && <p data-testid="festive-banner-subtitle" className="mt-3 text-sm sm:text-lg tracking-[0.18em] uppercase text-[#FDFBF7]/90">{b.subtitle}</p>}
        </div>
      </motion.div>
    </section>
  );
};
